import Header from "../../components/header";
import { Container, HeaderSection, ListContainer } from "../style";
import CreateBoardModal from "../../components/modals/createBoardModal";
import PaymentLogs from "../../components/paymentHistory/PaymentLogs";

const PaymentLogsPage = () => {
  const content = {
    tabTitle: "Payments",
    tabSubTitle: `Payment Logs`,
  };
  return (
    <Container>
      <HeaderSection>
        <Header content={content} hideCreateButton={true} />
        <ListContainer>
          <PaymentLogs />
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
    </Container>
  );
};

export default PaymentLogsPage;
